import Vue from 'vue'

import { isEmpty } from './helpers/objects'

import router from './routes'

let vue_params = {
    data: {
        country: window.country,
        is_mobile: null,
        is_mobile2: null,
        orientation: null,
        lang: {},
        loaderVisible: false,
        loading_count: 0,
        modal_is_open: false,
        network: window.network,
        new_cookies: window.new_cookies,
        ready: false,
        user_email: window.user_email,
        user_full_name: window.user_full_name,
        user_hash: window.user_hash,
    },

    computed: {
        country_full_name() {
            const countries = {
                es: 'spain',
                fr: 'france',
                hu: 'hungary',
                it: 'italy',
                tn: 'tunisia',
            }

            return countries[this.country.toLowerCase()]
        },

        hasLang() {
            return ! isEmpty(this.lang)
        },

        hasMarketingCookies() {
            let has_marketing = $cookies.get('cookie_retargeting') ? 1 : 0

            return this.new_cookies  && has_marketing
        },
    },

    created() {
        this.checkWindowSize()

        this.getLangFile()
    },

    mounted() {
        window.events.$on('isLoading', event => {
            this.loading_count += 1;
            this.loaderVisible = true
        })

        window.events.$on('stopLoading', event => {
            if(this.loading_count > 0)
                this.loading_count -= 1

            if(this.loading_count == 0)
                this.loaderVisible = false
        })

        window.addEventListener('resize', this.checkWindowSize)
    },

    methods: {
        checkWindowSize() {
            let is_mobile = window.innerWidth <= 769
            let is_mobile2 = window.innerWidth <= 1191

            this.setIsMobile(is_mobile)
            this.setIsMobile2(is_mobile2)
            
            let orientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'

            this.setOrientation(orientation)
        },

        // manageResizeEvent() {
        //     debounce(this.checkWindowSize, 100)
        // },

        setIsMobile(is_mobile){
            if(this.is_mobile !== is_mobile){
                this.is_mobile = is_mobile

                window.events.$emit('isMobileChanged', this.is_mobile)
            }
        },

        setIsMobile2(is_mobile2){
            if(this.is_mobile2 !== is_mobile2){
                this.is_mobile2 = is_mobile2

                window.events.$emit('isMobileChanged', this.is_mobile2)
            }
        },

        setOrientation(orientation){
            if(this.orientation !== orientation){
                this.orientation = orientation

                window.events.$emit('orientationChanged', this.orientation)
            }
        },

        getLangFile() {
            axios.get('/lang?language=' + window.language + '&hash=' + window.app_hash + '&route=' + window.route)
                .then(({data}) => {
                    this.lang = data

                    this.ready = true
                })
                .catch(error => {
                    this.ready = true
                })
        },

        openLoginModal() {
            window.events.$emit('showModal', { name: 'login', target: 'dashboard' })
        }
    },
}

if(window.route === 'user-area') {
    vue_params.router = router
}

window.events = new Vue()

const app = new Vue(vue_params).$mount('#app')

window.flash = function(message, type, seconds) {
    window.events.$emit('flash', message, type, seconds)
}

Vue.prototype.is_logged_in = function() {
    return this.$root.user_hash != ''
}

Vue.prototype.is_guest = function() {
    return ! this.$root.user_hash
}

Vue.prototype.trans = function(index, params) {
    let output = this.lang

    if(output) {
        let keys = index.split('.')

        keys.forEach(key => {
            output = output[key]
        })

        if(params) {
            for(let param in params) {
                output = output.replace(':' + param, params[param])
            }
        }

        return output
    }
}

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})
